import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from '../App';
import LoadingPage from './LoadingPage';

// Lazy load heavy routes to reduce initial bundle size
const GridPage = lazy(() => import('./GridPage'));
const GamePage = lazy(() => import('./GamePage'));

const AppRouter: React.FC = () => {
  return (
    <Router>
      <Suspense fallback={<LoadingPage />}>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/grid" element={<GridPage />} />
          <Route path="/love" element={<GamePage />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default AppRouter; 